import { render, staticRenderFns } from "./AppLiveStream.vue?vue&type=template&id=35e4f24b&scoped=true&"
import script from "./AppLiveStream.vue?vue&type=script&lang=js&"
export * from "./AppLiveStream.vue?vue&type=script&lang=js&"
import style0 from "./AppLiveStream.vue?vue&type=style&index=0&id=35e4f24b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4f24b",
  null
  
)

export default component.exports